import { atom } from 'jotai';
import { FRAME_DETAILS_STATUS } from '../../../workers/constants/frame-processor-constants';
import { frameImageUrlsAtom } from './frame-image-urls-atom';
import { frameDetailsStateAtom } from './video-playback-atoms';
export const isGridViewEnabledAtom = atom(false);
export const canEnableGridViewAtom = atom(get => {
  const frameImageUrls = get(frameImageUrlsAtom);
  if (frameImageUrls.length <= 1) {
    return false;
  }

  // For v2 (decode approach): Check extraction completed OR imageUrls exist
  // For v1 (original): Just needs imageUrls from inputData
  const frameDetailsState = get(frameDetailsStateAtom);
  const hasImageUrls = frameImageUrls.every(url => Boolean(url));
  const hasExtractedFrames = frameDetailsState.status === FRAME_DETAILS_STATUS.SUCCESS;
  return hasImageUrls || hasExtractedFrames;
});